/**
 * Created by Ivan on 10.03.2026
 */

const HungryGamesWindow = Prefab.createWindow("hungry_games_window", "hungrygameswindow_prefab_json");
